import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";

const TAG_TYPE_OPTIONS = [
  {
    value: "standard",
    label: "Standard",
    sub: "40 x 14mm",
    desc: "Great for most small sized products.",
  },
  {
    value: "mini",
    label: "Mini",
    sub: "22 x 14mm",
    desc: "Better for smaller sized products, the sides of bottles, cigarette boxes, even paper documents.",
  },
  {
    value: "flap",
    label: "Flap",
    sub: "115 x 14mm",
    desc: "Great for bottles, cans, boxes. Covers a wider area so can also act as a tamper seal.",
  },
  {
    value: "custom",
    label: "Custom",
    desc: "Request a custom design to meet your bespoke needs! We'll reach out to discuss your requirements.",
  },
];

const CATEGORIES = [
  "Agriculture",
  "Apparel",
  "Automobiles",
  "Beverages",
  "Construction",
  "Cosmetics",
  "Currencies",
  "Education",
  "Electronics",
  "Food",
  "Government",
  "Media",
  "Organizations",
  "Petroleum",
  "Pharmaceuticals",
];

const isEmail = (s) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s || "");

const inputStyle = {
  width: "100%",
  backgroundColor: "#fff",
  border: "1.5px solid #e5e7eb",
  borderRadius: 10,
  padding: "10px 14px",
  fontSize: 14,
  color: "#111827",
  outline: "none",
  transition: "border-color 0.15s, box-shadow 0.15s",
};

const focusHandlers = {
  onFocus: (e) => {
    e.target.style.borderColor = "#ff5100";
    e.target.style.boxShadow = "0 0 0 3px rgba(255,81,0,0.1)";
  },
  onBlur: (e) => {
    e.target.style.borderColor = "#e5e7eb";
    e.target.style.boxShadow = "none";
  },
};

const FieldLabel = ({ children }) => (
  <div
    style={{
      color: "#6b7280",
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: "0.06em",
      textTransform: "uppercase",
      marginBottom: 6,
    }}
  >
    {children}
  </div>
);

const RequestBleSTQuote = ({ show, handleClose, userData }) => {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [quantity, setQuantity] = useState("");
  const [tagType, setTagType] = useState("standard");
  const [cadence, setCadence] = useState("");
  const [role, setRole] = useState("");
  const [category, setCategory] = useState("");
  const [categories] = useState(CATEGORIES);
  const [message, setMessage] = useState("");
  const [files, setFiles] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!show) {
      setQuantity("");
      setTagType("standard");
      setCadence("");
      setRole("");
      setCategory("");
      setMessage("");
      setFiles([]);
      setSubmitted(false);
      return;
    }
    const contact = userData?.[3] || "";
    setEmail(isEmail(contact) ? contact : "");
    setPhone(!isEmail(contact) && contact ? contact : "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files);
    setFiles((prev) => [...prev, ...selected].slice(0, 5));
    e.target.value = "";
  };

  const removeFile = (index) =>
    setFiles((prev) => prev.filter((_, i) => i !== index));

  const handleSubmit = () => {
    if (!email.trim()) {
      alert("Please provide a contact email.");
      return;
    }
    if (!phone.trim()) {
      alert("Please provide a contact phone number.");
      return;
    }
    if (!cadence) {
      alert("Please select an order cadence.");
      return;
    }
    if (!category) {
      alert("Please select a product category.");
      return;
    }
    if (!message.trim()) {
      alert("Please provide a message describing your requirements.");
      return;
    }
    setSubmitted(true);
  };

  const isValid =
    email.trim() &&
    phone.trim() &&
    quantity &&
    cadence &&
    category &&
    message.trim();

  const fileLabel = (file) => {
    const ext = file.name.split(".").pop().toUpperCase();
    const kb = (file.size / 1024).toFixed(0);
    return `${ext} · ${kb} KB`;
  };

  return (
    <>
      <style>{`
        .blest-quote-modal .modal-content {
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 18px;
          box-shadow: 0 20px 60px rgba(0,0,0,0.12);
        }
        .blest-quote-modal .modal-header {
          background: #fff;
          border-bottom: 1px solid #f3f4f6;
          border-radius: 18px 18px 0 0;
          padding: 20px 24px 16px;
        }
        .blest-quote-modal .modal-body {
          background: #fff;
          padding: 20px 24px;
          max-height: 68vh;
          overflow-y: auto;
        }
        .blest-quote-modal .modal-footer {
          background: #f9fafb;
          border-top: 1px solid #f3f4f6;
          border-radius: 0 0 18px 18px;
          padding: 16px 24px;
        }
        .quote-tag-btn {
          flex: 1;
          padding: 10px 10px;
          border-radius: 10px;
          border: 1.5px solid #e5e7eb;
          background: #fff;
          cursor: pointer;
          text-align: center;
          transition: border-color 0.15s, background 0.15s;
          font-size: 13px;
          font-weight: 700;
          color: #374151;
        }
        .quote-tag-btn.active {
          border-color: #ff5100;
          background: rgba(255,81,0,0.06);
          color: #c13d00;
        }
        .quote-tag-btn:hover:not(.active) {
          border-color: #d1d5db;
          background: #f9fafb;
        }
        .quote-select {
          width: 100%;
          background-color: #fff;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%239ca3af'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 14px center;
          background-size: 10px;
          -webkit-appearance: none;
          appearance: none;
          border: 1.5px solid #e5e7eb;
          border-radius: 10px;
          padding: 10px 36px 10px 14px;
          font-size: 14px;
          color: #111827;
          outline: none;
          cursor: pointer;
          transition: border-color 0.15s, box-shadow 0.15s;
        }
        .quote-select:focus {
          border-color: #ff5100;
          box-shadow: 0 0 0 3px rgba(255,81,0,0.1);
        }
        .quote-file-chip {
          display: inline-flex; align-items: center; gap: 7px;
          background: #f3f4f6; border: 1px solid #e5e7eb; border-radius: 8px;
          padding: 5px 10px; font-size: 12px; color: #374151; font-weight: 600;
        }
        .quote-file-remove {
          border: none; background: none; color: #9ca3af;
          cursor: pointer; font-size: 12px; padding: 0; line-height: 1;
        }
        .quote-file-remove:hover { color: #dc2626; }
      `}</style>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        dialogClassName="blest-quote-modal"
        centered
        size="lg"
        style={{ backdropFilter: "blur(3px)" }}
      >
        <Modal.Header closeButton>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
              style={{
                width: 34,
                height: 34,
                borderRadius: 9,
                background: "rgba(255,81,0,0.08)",
                border: "1.5px solid rgba(255,81,0,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i
                className="fas fa-tags"
                style={{ color: "#ff5100", fontSize: 14 }}
              />
            </div>
            <div>
              <div style={{ fontWeight: 800, fontSize: 16, color: "#111827" }}>
                Request a BleST Tag Quote
              </div>
              <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 1 }}>
                Tell us what you need and we'll get back to you
              </div>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          {submitted ? (
            <div style={{ textAlign: "center", padding: "36px 16px" }}>
              <div
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  margin: "0 auto 20px",
                  background: "rgba(5,150,105,0.08)",
                  border: "2px solid rgba(5,150,105,0.25)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i
                  className="fas fa-check"
                  style={{ color: "#059669", fontSize: 26 }}
                />
              </div>
              <div
                style={{
                  fontWeight: 800,
                  fontSize: 18,
                  color: "#111827",
                  marginBottom: 10,
                }}
              >
                Quote Request Submitted
              </div>
              <div
                style={{
                  fontSize: 14,
                  color: "#6b7280",
                  lineHeight: 1.8,
                  maxWidth: 380,
                  margin: "0 auto",
                }}
              >
                We've received your request and will reach out with a quote
                within{" "}
                <strong style={{ color: "#111827" }}>1–2 business days</strong>.
                If you need assistance sooner, visit our{" "}
                <a
                  href="/contact"
                  style={{
                    color: "#ff5100",
                    fontWeight: 700,
                    textDecoration: "none",
                  }}
                >
                  contact page
                </a>
                .
              </div>
              <button
                onClick={handleClose}
                style={{
                  marginTop: 28,
                  padding: "10px 30px",
                  borderRadius: 10,
                  border: "none",
                  background:
                    "linear-gradient(135deg, #c13d00 0%, #ff5100 100%)",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: 14,
                  cursor: "pointer",
                }}
              >
                Done
              </button>
            </div>
          ) : (
            <>
              {/* Info banner */}
              <div
                style={{
                  background: "#fff7f3",
                  border: "1.5px solid rgba(255,81,0,0.2)",
                  borderRadius: 10,
                  padding: "10px 14px",
                  display: "flex",
                  gap: 10,
                  alignItems: "flex-start",
                  marginBottom: 20,
                }}
              >
                <i
                  className="fas fa-circle-info"
                  style={{
                    color: "#ff5100",
                    fontSize: 13,
                    marginTop: 1,
                    flexShrink: 0,
                  }}
                />
                <div
                  style={{ fontSize: 12.5, color: "#c13d00", lineHeight: 1.65 }}
                >
                  Fill in the details below and we'll reach out to your contact
                  with a quote within <strong>1–2 business days</strong>. You
                  can also reach out to us directly{" "}
                  <a
                    href="/contact"
                    style={{ color: "#c13d00", fontWeight: 700 }}
                  >
                    here
                  </a>{" "}
                  for tailored assistance.
                </div>
              </div>

              {/* Contact */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 14,
                  marginBottom: 16,
                }}
              >
                <div>
                  <FieldLabel>Contact Email *</FieldLabel>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    style={inputStyle}
                    {...focusHandlers}
                  />
                </div>
                <div>
                  <FieldLabel>Contact Phone *</FieldLabel>
                  <input
                    type="tel"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="+256 700 000 000"
                    style={inputStyle}
                    {...focusHandlers}
                  />
                </div>
              </div>

              {/* Role */}
              <div style={{ marginBottom: 16 }}>
                <FieldLabel>Your Role</FieldLabel>
                <select
                  className="quote-select"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                >
                  <option value="">Select your role…</option>
                  <option value="Owner / Founder">Owner / Founder</option>
                  <option value="Brand Manager">Brand Manager</option>
                  <option value="Procurement Manager">
                    Procurement Manager
                  </option>
                  <option value="Marketing Manager">Marketing Manager</option>
                  <option value="Operations Manager">Operations Manager</option>
                  <option value="Sales Representative">
                    Sales Representative
                  </option>
                  <option value="Other">Other</option>
                </select>
              </div>

              {/* Category */}
              <div style={{ marginBottom: 16 }}>
                <FieldLabel>Product Category *</FieldLabel>
                <select
                  className="quote-select"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                >
                  <option value="">Select a product category…</option>
                  {categories.map((c) => (
                    <option
                      key={c}
                      value={c}
                    >
                      {c}
                    </option>
                  ))}
                </select>
              </div>

              {/* Quantity */}
              <div style={{ marginBottom: 16 }}>
                <FieldLabel>Quantity of BleST Tags *</FieldLabel>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  {["10,000", "50,000", "100,000", "500,000", "1M+"].map(
                    (opt) => (
                      <button
                        key={opt}
                        type="button"
                        className={`quote-tag-btn${quantity === opt ? " active" : ""}`}
                        onClick={() => setQuantity(opt)}
                        style={{ flex: "1 1 auto" }}
                      >
                        {opt}
                      </button>
                    ),
                  )}
                </div>
                <div style={{ fontSize: 11.5, color: "#9ca3af", marginTop: 7 }}>
                  Minimum order quantity is 10,000 tags.
                </div>
              </div>

              {/* Tag type */}
              <div style={{ marginBottom: 16 }}>
                <FieldLabel>Tag Size *</FieldLabel>
                <div style={{ display: "flex", gap: 10 }}>
                  {TAG_TYPE_OPTIONS.map((opt) => (
                    <button
                      key={opt.value}
                      type="button"
                      className={`quote-tag-btn${tagType === opt.value ? " active" : ""}`}
                      onClick={() => setTagType(opt.value)}
                    >
                      <div>{opt.label}</div>
                      {opt.sub && (
                        <div
                          style={{
                            fontSize: 11,
                            fontWeight: 500,
                            marginTop: 2,
                            color:
                              tagType === opt.value ? "#ff5100" : "#9ca3af",
                          }}
                        >
                          {opt.sub}
                        </div>
                      )}
                    </button>
                  ))}
                </div>
                {(() => {
                  const selected = TAG_TYPE_OPTIONS.find(
                    (o) => o.value === tagType,
                  );
                  return selected?.desc ? (
                    <div
                      style={{
                        marginTop: 10,
                        background: "#f0f9ff",
                        border: "1.5px solid #bae6fd",
                        borderRadius: 10,
                        padding: "10px 14px",
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                      }}
                    >
                      <div
                        style={{
                          width: 34,
                          height: 34,
                          borderRadius: 9,
                          flexShrink: 0,
                          background: "rgba(2,132,199,0.1)",
                          border: "1.5px solid rgba(2,132,199,0.25)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <i
                          className="fas fa-circle-info"
                          style={{ color: "#0284c7", fontSize: 13 }}
                        />
                      </div>
                      <div
                        style={{
                          fontSize: 12.5,
                          color: "#0369a1",
                          fontWeight: 600,
                          lineHeight: 1.6,
                        }}
                      >
                        {selected.desc}
                      </div>
                    </div>
                  ) : null;
                })()}
              </div>

              {/* Order Cadence */}
              <div style={{ marginBottom: 16 }}>
                <FieldLabel>Order Cadence *</FieldLabel>
                <div style={{ display: "flex", gap: 10 }}>
                  {["One-time", "Monthly", "Annual"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={`quote-tag-btn${cadence === opt ? " active" : ""}`}
                      onClick={() => setCadence(opt)}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
              </div>

              {/* Message */}
              <div style={{ marginBottom: 16 }}>
                <FieldLabel>Message / Description *</FieldLabel>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Describe your requirements: intended use, product details, dispatch volumes, any specific needs…"
                  style={{ ...inputStyle, resize: "vertical", minHeight: 100 }}
                  {...focusHandlers}
                />
              </div>

              {/* Attachments */}
              <div>
                <FieldLabel>
                  Attachments{" "}
                  <span
                    style={{
                      textTransform: "none",
                      fontWeight: 500,
                      color: "#9ca3af",
                      fontSize: 11,
                    }}
                  >
                    (max 5 · JPG, PNG, PDF)
                  </span>
                </FieldLabel>
                <div
                  style={{
                    fontSize: 12,
                    color: "#6b7280",
                    marginBottom: 8,
                    lineHeight: 1.6,
                  }}
                >
                  Upload your brand logo, label designs, product or packaging
                  photos, and any other relevant references.
                </div>

                {files.length < 5 && (
                  <>
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/jpeg,image/png,.pdf"
                      multiple
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                    <button
                      type="button"
                      onClick={() => fileInputRef.current?.click()}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 7,
                        padding: "8px 14px",
                        borderRadius: 9,
                        border: "1.5px dashed #d1d5db",
                        background: "transparent",
                        color: "#6b7280",
                        fontSize: 13,
                        fontWeight: 600,
                        cursor: "pointer",
                        transition: "border-color 0.15s, color 0.15s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = "#ff5100";
                        e.currentTarget.style.color = "#ff5100";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = "#d1d5db";
                        e.currentTarget.style.color = "#6b7280";
                      }}
                    >
                      <i
                        className="fas fa-paperclip"
                        style={{ fontSize: 12 }}
                      />
                      Attach files
                      {files.length > 0 ? ` (${files.length}/5)` : ""}
                    </button>
                  </>
                )}

                {files.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 8,
                      marginTop: 10,
                    }}
                  >
                    {files.map((f, i) => (
                      <span
                        className="quote-file-chip"
                        key={i}
                      >
                        <i
                          className={`fas ${f.type === "application/pdf" ? "fa-file-pdf" : "fa-image"}`}
                          style={{ fontSize: 12, color: "#6b7280" }}
                        />
                        <span
                          style={{
                            maxWidth: 150,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {f.name}
                        </span>
                        <span
                          style={{
                            color: "#9ca3af",
                            fontSize: 11,
                            fontWeight: 400,
                          }}
                        >
                          {fileLabel(f)}
                        </span>
                        <button
                          className="quote-file-remove"
                          onClick={() => removeFile(i)}
                          title="Remove"
                        >
                          <i className="fas fa-times" />
                        </button>
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </>
          )}
        </Modal.Body>

        {!submitted && (
          <Modal.Footer>
            <button
              type="button"
              onClick={handleSubmit}
              disabled={!isValid}
              style={{
                width: "100%",
                padding: "11px 0",
                borderRadius: 10,
                border: "none",
                background: isValid
                  ? "linear-gradient(135deg, #c13d00 0%, #ff5100 100%)"
                  : "#e5e7eb",
                color: isValid ? "#fff" : "#9ca3af",
                fontWeight: 700,
                fontSize: 15,
                cursor: isValid ? "pointer" : "not-allowed",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 9,
                transition: "background 0.15s, color 0.15s",
              }}
            >
              Submit Quote Request
              <i
                className="fas fa-arrow-right"
                style={{ fontSize: 13 }}
              />
            </button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
};

export default RequestBleSTQuote;
